'use client';

import { useState, useMemo } from 'react';
import { useFlagSetter } from '../useFlagSetter.ts';
import type { UseSubmitStateReturn } from '@federa/types/react-hook-state';

/** Hook for managing submitting/saving state: `{ isSubmitting, start, stop }`. */
export function useSubmitState(): UseSubmitStateReturn {
	const [isSubmitting, setIsSubmitting] = useState(false);
	const start = useFlagSetter(setIsSubmitting, true);
	const stop = useFlagSetter(setIsSubmitting, false);

	return useMemo(() => ({ isSubmitting, start, stop, setIsSubmitting }), [isSubmitting, start, stop]);
}
